import { cloneElement, useId, type ReactElement } from "react";

type FormControlProps = {
  "aria-describedby"?: string;
  "aria-invalid"?: boolean;
  "aria-labelledby"?: string;
  "aria-required"?: boolean;
};

type StayResourceFormRowProps = {
  label: string;
  required?: boolean;
  error?: string;
  children: ReactElement<FormControlProps>;
};

/** 渲染住宿资源表单的标签、控件与就地错误。 */
export function StayResourceFormRow({
  label,
  required = false,
  error,
  children,
}: StayResourceFormRowProps) {
  const id = useId();
  const labelId = `${id}-label`;
  const errorId = `${id}-error`;
  return (
    <div className="stay-resource-form-row">
      <div id={labelId} className="stay-resource-form-row__label">
        {required ? <span aria-hidden="true">*</span> : null}{label}
      </div>
      <div className="stay-resource-form-row__control">
        {cloneElement(children, {
          "aria-labelledby": labelId,
          "aria-required": required || undefined,
          "aria-invalid": Boolean(error) || undefined,
          "aria-describedby": error ? errorId : undefined,
        })}
        {error ? <div id={errorId} role="alert" className="stay-resource-form-error">{error}</div> : null}
      </div>
    </div>
  );
}
